
import { CaseStudyTemplate } from '@/components/case-studies/CaseStudyTemplate';
import { faBell, faRobot, faLink } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export default function ViolenceDetectionCaseStudy() {
  const { t } = useTranslation();

  return (
    <CaseStudyTemplate
      id="violence"
      title={t('caseStudies.violence.title')}
      description={t('caseStudies.violence.description')}
      video="/Violance.mp4"
      image="/images/case-studies/violence-detection-hero.jpg"
      problem={t('caseStudies.violence.problem')}
        solution={t('caseStudies.violence.solution')}
        results={t('caseStudies.violence.results')}
        features={[
          {
            title: t('caseStudies.violence.features[0].title'),
            description: t('caseStudies.violence.features[0].description'),
            icon: faBell
          },
          {
            title: t('caseStudies.violence.features[1].title'),
            description: t('caseStudies.violence.features[1].description'),
            icon: faRobot
          },
          {
            title: t('caseStudies.violence.features[2].title'),
            description: t('caseStudies.violence.features[2].description'),
            icon: faLink
          }
        ]}
        faqs={t('caseStudies.violence.faq', { returnObjects: true }) as Array<{id?: string, question: string, answer: string}>}
      />
  );
}
